// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.risk-register-breadcrumb {
  display: flex;
  align-items: center;
  margin: 5px 0;
  padding-left: 4px;
}

.breadcrumb-icon {
  color: #666;
  font-size: 22px;
  margin: 12px 10px 12px 12px;
}

.breadcrumb-separator {
  margin: 0 8px;
  color: #666;
  font-size: 16px;
}

.risk-register-page .aptsi-card {
  text-align: left;
}

.risk-register-content {
  text-align: left;
}

.risk-register-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.risk-register-toolbar-left {
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1 1 520px;
  min-width: 0;
}

.risk-register-search {
  flex: 1 1 280px;
  min-width: 220px;
  max-width: 420px;
}

.risk-register-search .form-control {
  min-width: 0;
  width: 100%;
}

.risk-register-filter {
  flex: 0 0 200px;
  height: 40px;
  min-width: 180px;
}

.form-inputs .form-control {
  height: 40px;
}

.form-inputs .form-control:focus {
  box-shadow: none;
  border: 1px solid #000;
}

.form-inputs {
  display: flex;
  align-items: stretch;
}

.search-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin: 0;
  border: none;
  background-color: #333742;
  padding: 0 14px;
  color: rgb(210, 207, 207);
  border-radius: 0 4px 4px 0;
  cursor: pointer;
}
.search-icon i {
  font-size: 16px;
  line-height: 1;
}
.search-icon:hover {
  color: white;
  background-color: #3b71ca;
  transition: all 0.4s ease-in-out;
}

.risk-register-search .form-control {
  border-radius: 4px 0 0 4px;
}

.risk-register-add-action {
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 0 1 auto;
}
.risk-register-add-action .add-icon {
  font-size: 1.75rem;
  line-height: 1;
  color: #333742;
  cursor: pointer;
}
.risk-register-add-action .add-icon:hover {
  color: #3b71ca;
}
.risk-register-add-action .add-label {
  font-size: 18px;
  font-weight: 300;
  color: #212529;
  white-space: nowrap;
  cursor: pointer;
  text-decoration: none;
}
.risk-register-add-action .add-label:hover {
  color: #3b71ca;
}
.risk-register-add-action .info-icon {
  font-size: 16px;
  color: #000;
  cursor: pointer;
  line-height: 1;
}
.risk-register-add-action .info-icon:hover {
  opacity: 0.7;
}

.risk-register-table-section {
  width: 100%;
}

.risk-register-grid {
  width: 100%;
}

::ng-deep .risk-register-grid .ag-root-wrapper {
  border: none;
}

::ng-deep .risk-register-info-tooltip {
  max-width: 280px;
  text-align: left;
}

.risk-register-empty {
  padding: 48px 16px;
}
.risk-register-empty .empty-icon {
  font-size: 50px;
  color: gray;
}
.risk-register-empty .empty-message {
  font-size: 18px;
  padding-top: 8px;
  margin: 0;
}

.risk-register-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 12px;
  padding-top: 0;
  width: 100%;
}

.risk-register-footer app-pagination {
  display: flex;
  justify-content: flex-end;
}

::ng-deep .risk-register-footer .pagination {
  margin-bottom: 0;
  flex-wrap: wrap;
  justify-content: flex-end;
}

.ag-theme-quartz {
  --ag-header-background-color: #3b71ca;
}

::ng-deep .custom-table .ag-header-cell-text {
  color: rgb(255, 255, 255) !important;
}

::ng-deep .custom-table .ag-row {
  cursor: pointer;
}

::ng-deep .custom-table .risk-register-actions-cell {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 12px;
  height: 100%;
}

::ng-deep .custom-table .risk-register-action {
  cursor: pointer;
  padding: 4px 6px;
  display: inline-flex;
  align-items: center;
  line-height: 1;
}

::ng-deep .custom-table .risk-register-action i {
  font-size: 16px;
  pointer-events: none;
}

@media (max-width: 992px) {
  .risk-register-toolbar {
    align-items: stretch;
  }
  .risk-register-toolbar-left {
    flex-direction: column;
    align-items: stretch;
    max-width: 100%;
  }
  .risk-register-search {
    max-width: none;
  }
  .risk-register-filter {
    flex: 1 1 auto;
    width: 100%;
  }
  .risk-register-add-action {
    padding-top: 4px;
  }
  .risk-register-footer {
    flex-direction: column;
    align-items: stretch;
  }
  ::ng-deep .risk-register-footer .pagination {
    justify-content: center;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/features/insight-egrc/risk-management/risk-register/risk-register-search/risk-register-search.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;AACF;;AAEA;EACE,WAAA;EACA,eAAA;EACA,2BAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;EACA,eAAA;AACF;;AAGE;EACE,gBAAA;AAAJ;;AAIA;EACE,gBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,mBAAA;EACA,eAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;EACA,YAAA;AADF;;AAIA;EACE,eAAA;EACA,gBAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;EACA,WAAA;AADF;;AAIA;EACE,eAAA;EACA,YAAA;EACA,gBAAA;AADF;;AAIA;EACE,YAAA;AADF;;AAIA;EACE,gBAAA;EACA,sBAAA;AADF;;AAIA;EACE,aAAA;EACA,oBAAA;AADF;;AAIA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,yBAAA;EACA,eAAA;EACA,yBAAA;EACA,0BAAA;EACA,eAAA;AADF;AAGE;EACE,eAAA;EACA,cAAA;AADJ;AAIE;EACE,YAAA;EACA,yBAAA;EACA,gCAAA;AAFJ;;AAMA;EACE,0BAAA;AAHF;;AAMA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,cAAA;AAHF;AAKE;EACE,kBAAA;EACA,cAAA;EACA,cAAA;EACA,eAAA;AAHJ;AAKI;EACE,cAAA;AAHN;AAOE;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,qBAAA;AALJ;AAOI;EACE,cAAA;AALN;AASE;EACE,eAAA;EACA,WAAA;EACA,eAAA;EACA,cAAA;AAPJ;AASI;EACE,YAAA;AAPN;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,WAAA;AATF;;AAYA;EACE,YAAA;AATF;;AAYA;EACE,gBAAA;EACA,gBAAA;AATF;;AAYA;EACE,kBAAA;AATF;AAWE;EACE,eAAA;EACA,WAAA;AATJ;AAYE;EACE,eAAA;EACA,gBAAA;EACA,SAAA;AAVJ;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAXF;;AAcA;EACE,aAAA;EACA,yBAAA;AAXF;;AAcA;EACE,gBAAA;EACA,eAAA;EACA,yBAAA;AAXF;;AAcA;EACE,qCAAA;AAXF;;AAcA;EACE,oCAAA;AAXF;;AAcA;EACE,eAAA;AAXF;;AAcA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,YAAA;AAXF;;AAcA;EACE,eAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,cAAA;AAXF;;AAcA;EACE,eAAA;EACA,oBAAA;AAXF;;AAcA;EACE;IACE,oBAAA;EAXF;EAcA;IACE,sBAAA;IACA,oBAAA;IACA,eAAA;EAZF;EAeA;IACE,eAAA;EAbF;EAgBA;IACE,cAAA;IACA,WAAA;EAdF;EAiBA;IACE,gBAAA;EAfF;EAkBA;IACE,sBAAA;IACA,oBAAA;EAhBF;EAmBA;IACE,uBAAA;EAjBF;AACF","sourcesContent":[".risk-register-breadcrumb {\n  display: flex;\n  align-items: center;\n  margin: 5px 0;\n  padding-left: 4px;\n}\n\n.breadcrumb-icon {\n  color: #666;\n  font-size: 22px;\n  margin: 12px 10px 12px 12px;\n}\n\n.breadcrumb-separator {\n  margin: 0 8px;\n  color: #666;\n  font-size: 16px;\n}\n\n.risk-register-page {\n  .aptsi-card {\n    text-align: left;\n  }\n}\n\n.risk-register-content {\n  text-align: left;\n}\n\n.risk-register-toolbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 20px;\n  flex-wrap: wrap;\n}\n\n.risk-register-toolbar-left {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex: 1 1 520px;\n  min-width: 0;\n}\n\n.risk-register-search {\n  flex: 1 1 280px;\n  min-width: 220px;\n  max-width: 420px;\n}\n\n.risk-register-search .form-control {\n  min-width: 0;\n  width: 100%;\n}\n\n.risk-register-filter {\n  flex: 0 0 200px;\n  height: 40px;\n  min-width: 180px;\n}\n\n.form-inputs .form-control {\n  height: 40px;\n}\n\n.form-inputs .form-control:focus {\n  box-shadow: none;\n  border: 1px solid #000;\n}\n\n.form-inputs {\n  display: flex;\n  align-items: stretch;\n}\n\n.search-icon {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  margin: 0;\n  border: none;\n  background-color: #333742;\n  padding: 0 14px;\n  color: rgb(210, 207, 207);\n  border-radius: 0 4px 4px 0;\n  cursor: pointer;\n\n  i {\n    font-size: 16px;\n    line-height: 1;\n  }\n\n  &:hover {\n    color: white;\n    background-color: #3b71ca;\n    transition: all 0.4s ease-in-out;\n  }\n}\n\n.risk-register-search .form-control {\n  border-radius: 4px 0 0 4px;\n}\n\n.risk-register-add-action {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n  flex: 0 1 auto;\n\n  .add-icon {\n    font-size: 1.75rem;\n    line-height: 1;\n    color: #333742;\n    cursor: pointer;\n\n    &:hover {\n      color: #3b71ca;\n    }\n  }\n\n  .add-label {\n    font-size: 18px;\n    font-weight: 300;\n    color: #212529;\n    white-space: nowrap;\n    cursor: pointer;\n    text-decoration: none;\n\n    &:hover {\n      color: #3b71ca;\n    }\n  }\n\n  .info-icon {\n    font-size: 16px;\n    color: #000;\n    cursor: pointer;\n    line-height: 1;\n\n    &:hover {\n      opacity: 0.7;\n    }\n  }\n}\n\n.risk-register-table-section {\n  width: 100%;\n}\n\n.risk-register-grid {\n  width: 100%;\n}\n\n::ng-deep .risk-register-grid .ag-root-wrapper {\n  border: none;\n}\n\n::ng-deep .risk-register-info-tooltip {\n  max-width: 280px;\n  text-align: left;\n}\n\n.risk-register-empty {\n  padding: 48px 16px;\n\n  .empty-icon {\n    font-size: 50px;\n    color: gray;\n  }\n\n  .empty-message {\n    font-size: 18px;\n    padding-top: 8px;\n    margin: 0;\n  }\n}\n\n.risk-register-footer {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-top: 12px;\n  padding-top: 0;\n  width: 100%;\n}\n\n.risk-register-footer app-pagination {\n  display: flex;\n  justify-content: flex-end;\n}\n\n::ng-deep .risk-register-footer .pagination {\n  margin-bottom: 0;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n}\n\n.ag-theme-quartz {\n  --ag-header-background-color: #3b71ca;\n}\n\n::ng-deep .custom-table .ag-header-cell-text {\n  color: rgb(255, 255, 255) !important;\n}\n\n::ng-deep .custom-table .ag-row {\n  cursor: pointer;\n}\n\n::ng-deep .custom-table .risk-register-actions-cell {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  height: 100%;\n}\n\n::ng-deep .custom-table .risk-register-action {\n  cursor: pointer;\n  padding: 4px 6px;\n  display: inline-flex;\n  align-items: center;\n  line-height: 1;\n}\n\n::ng-deep .custom-table .risk-register-action i {\n  font-size: 16px;\n  pointer-events: none;\n}\n\n@media (max-width: 992px) {\n  .risk-register-toolbar {\n    align-items: stretch;\n  }\n\n  .risk-register-toolbar-left {\n    flex-direction: column;\n    align-items: stretch;\n    max-width: 100%;\n  }\n\n  .risk-register-search {\n    max-width: none;\n  }\n\n  .risk-register-filter {\n    flex: 1 1 auto;\n    width: 100%;\n  }\n\n  .risk-register-add-action {\n    padding-top: 4px;\n  }\n\n  .risk-register-footer {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  ::ng-deep .risk-register-footer .pagination {\n    justify-content: center;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
